<rt-box variant="no-padding" layout-vertical>
  <div class="section-field__header">
    <div class="section-field__accent-bar"></div>
    @if (title()) {
      <rt-heading variant="heading large block">{{ title() }}</rt-heading>
    }
    @if (description()) {
      <div>{{ description() }}</div>
    }
  </div>
</rt-box>
